import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'split' })
export class SplitStringPipe implements PipeTransform {
  transform(
    value: string,
    separator,
    startIndexReturnValue?: number,
    endIndexReturnValue?: number
  ): string {
    const splitString = value.split(separator);

    if (
      typeof startIndexReturnValue === 'number' ||
      typeof endIndexReturnValue === 'number'
    ) {
      return splitString
        .slice(startIndexReturnValue, endIndexReturnValue)
        .toString();
    }
    return splitString.toString();
  }
}
